import { useSessionStorage } from 'usehooks-ts';

import { SESSION_STORAGE_KEYS } from '../../../../utils/common/session-storage-keys';

export enum ConversionFlag {
  /** 아직 아무것도 하지 않은 상태 */
  IDLE = 'IDLE',
  /** 리다이렉트 필요한 상태 */
  NEED_REDIRECT = 'NEED_REDIRECT',
  /** 진행중인 상태 */
  ONGOING = 'ONGOING',
}

const useConversionSubscriptionGift = () => {
  // 구독 플로우에서 선물 전환을 위한 crm 으로 부터 진행중임을 알려주는 플래그
  const [conversionFlag, setConversionFlag, resetConversionFlag] =
    useSessionStorage<ConversionFlag>(
      SESSION_STORAGE_KEYS.SUBSCRIPTION_GIFT_CONVERSION_FLAG,
      ConversionFlag.IDLE,
    );

  // 구독 생성시 필요한 구독 선물 아이디
  const [
    subscriptionGiftUUID,
    setSubscriptionGiftUUID,
    resetSubscriptionGiftUUID,
  ] = useSessionStorage<string | null>(
    SESSION_STORAGE_KEYS.SUBSCRIPTION_GIFT_UUID,
    null,
  );

  return {
    conversionFlag,
    setConversionFlag,
    resetConversionFlag,
    subscriptionGiftUUID,
    setSubscriptionGiftUUID,
    resetSubscriptionGiftUUID,
  };
};

export default useConversionSubscriptionGift;
